import React, { useEffect, useRef, useState, useCallback, useContext } from "react";
import "../../styles/Broadcast.css";
import { Tabs, Input, List, Typography, Empty, Card, Button, ConfigProvider } from "antd";
import { SearchOutlined, TeamOutlined, DeleteOutlined } from "@ant-design/icons";
import FileDownload from "./FileDownload";
import Loader from "../../../../components/commonComponents/Loader/Index";
import { read, utils } from "xlsx";
import { uploadFile } from "../../../../helper/uploadFile";

import { broadcastPartApi, broadcastPartFileData, broadcastPartDeleteApi, getBroadcastPartApi } from "../../api/Api";
import { AudienceSetMembersList, AudienceSetList } from "../../../crm/api/Api";
import {
  useAspDispatch,
  useAspSelector,
} from "../../../../test/jest-redux-hooks";
import { updateToggleToast } from "../../../../reduxToolkit/appSlice";
import { ICONS } from "../../../../assets/icons";
import {
  setDelayValue,
  setDelayValue1,
  setError,
  setSelectedDate,
  setSelectedDate1,
  setSelectedDateMerge,
  setSelectedTime,
  setSelectedTime1,
  setSelectedTimeMerge,
} from "../../../../reduxToolkit/broadcastSlice";
import { gainwix_icons } from "../../../../api/ApiConfig";
import NotificationContext from "../../../../providers/NotificationProvider";
import { showSuccessToast, showErrorToast } from "../../../../components/commonComponents/gxAntdToast/toastUtils";
import { Base64 } from "js-base64";
import Group from "../../../../assets/customSVG/Group";

const Define_Audience = ({
  response,
  setResponse,
  selectedIndex,
  broadCasts,
  setSelectedId1,
  broadcastId,
  response1,
  setResponse1,
  setIndexRem,
  indexRem,
  setSelectedIndexSegments,
}) => {
  const [fileLoader, setFileLoader] = useState(false);
  const [activeTab, setActiveTab] = useState('file-upload');
  const [audienceSets, setAudienceSets] = useState([]);
  const [searchQuery, setSearchQuery] = useState('');
  const [loading, setLoading] = useState(false);
  const [selectedAudience, setSelectedAudience] = useState(null);
  const [selectedBroadcastPartType, setSelectedBroadcastPartType] = useState(null);
  const dispatch = useAspDispatch();
  const { toggleToast, currentBrand, featureFlags } = useAspSelector((state) => state.app);
  const { dateCombine } = useAspSelector((state) => state?.Campaign);

  const notification = useContext(NotificationContext);
  const [broadcastPartId, setBroadcastPartId] = useState([]);
  const id = broadcastId;
  const isAudienceManagementSystemEnabled = featureFlags?.ams_feature;

  const downloadUrl = `${gainwix_icons}/assets/gainwix-images/sample_customers_file.xlsx`;

  // Fetch existing broadcast parts on mount
  useEffect(() => {
    const fetchBroadcastParts = async () => {
      if (broadcastId) {
        try {
          const res = await getBroadcastPartApi(broadcastId, currentBrand?.brand_id);
          if (res?.data?.broadcast_parts?.length > 0) {
            const part = res.data.broadcast_parts[0]; // Get the first part
            setSelectedBroadcastPartType(part.type);
            
            // Set the active tab based on the part type
            if (isAudienceManagementSystemEnabled && part.type === 'audience_set') {
              setActiveTab('audience-set');
              setSelectedAudience({
                id: part.audience_set_id,
                name: part.audience_set_name,
                created_at: part.audience_set_created_at,
                broadcastPartId: part.broadcastPartId,
                memberCount: part.valid_count
              });
            } else {
              setActiveTab('file-upload');
            }
          }
        } catch (error) {
          console.error('Error fetching broadcast parts:', error);
        }
      }
    };

    fetchBroadcastParts();
  }, [broadcastId]);

  // Update selectedId1 based on response and broadcast part type
  useEffect(() => {
    if (!response) return;
    if (response?.length === 0 && !selectedBroadcastPartType) {
      setSelectedId1(false);
      // Clear the selected broadcast part type when no items are left
      setSelectedBroadcastPartType(null);
    } else {
      setSelectedId1(true);
    }
  }, [response, selectedBroadcastPartType]);

  const handleDrag = (e) => {
    e.preventDefault();
    e.stopPropagation();
  };

  const handleDrop = (e) => {
    e.preventDefault();
    e.stopPropagation();

    if (e.dataTransfer.files && e.dataTransfer.files[0]) {
      handleFile(e.dataTransfer.files[0]);
    }
  };

  const handleChange = (e) => {
    const selectedFile = e.target.files[0];
    const selectedFileName = selectedFile?.name?.trim();

    const isDuplicate = response?.some((file) => {
      const file_name = file?.file_name?.trim();

      const lastDotIndex = selectedFileName.lastIndexOf(".");
      const selectedFileNameWithoutExtension =
        lastDotIndex !== -1
          ? selectedFileName.substring(0, lastDotIndex)
          : selectedFileName;

      return file_name === selectedFileNameWithoutExtension;
    });

    if (response?.length < 2) {
      if (!isDuplicate) {
        handleFile(selectedFile);
      } else {
        showErrorToast(notification,"File with the same name already exists");
      }
    } else {
      showErrorToast("You can only upload up to 2 files");
    }
    e.target.value = "";
    if (indexRem) {
      response1 = response1.map((item) => {
        if (item.segments.length !== 1) {
          const updatedSegment = {
            ...item.segments[1],
            end: 0,
            start: 0,
            delay: 0,
            id: 1,
          };

          return { ...item, segments: [updatedSegment] };
        }
        return item;
      });
    }
    setIndexRem(false);
  };

  const handleFile = async (file) => {
    // Don't allow file upload if an audience set is selected
    if (selectedBroadcastPartType && selectedBroadcastPartType === 'audience_set') {
      showErrorToast(notification, 'Please remove the selected audience set before uploading a file');
      return;
    }

    const filesName = file?.name?.split(".")[0];
    setFileLoader(true);
    setSelectedId1(false);
    
    // Set the selected broadcast part type
    setSelectedBroadcastPartType('file_upload');

    // Clear all previous selections
    dispatch(setSelectedDateMerge({ type: "clear" }));
    dispatch(setSelectedTimeMerge({ type: "clear" }));
    dispatch(setSelectedTime({ type: "clear" }));
    dispatch(setSelectedTime1({ type: "clear" }));
    dispatch(setDelayValue1(0));
    dispatch(setDelayValue({}));
    setSelectedIndexSegments(false);
    dispatch(setError(null));

    const phoneRegex =
      /^(91 \d{10,11}|65 [89]\d{7}|60 \d{9,10}|971 \d{8,9}|1 \d{10}|44 \d{10}|61 \d{9}|353 \d{9,10}|94 \d{9,10}|27 \d{9}|974 \d{8}|254 \d{9}|234 \d{7,10}|972 \d{8,9}|63 \d{10}|973 \d{8}|965 \d{8}|977 \d{10}|64 \d{8,9}|966 \d{9}|66 \d{9}|260 \d{9}|880 \d{9,11})$/;

    try {
      const responseFile = await uploadFile(file);
      const data = await file.arrayBuffer();
      const workbook = read(data, { type: "array" });
      const firstSheetName = workbook.SheetNames[0];
      const worksheet = workbook.Sheets[firstSheetName];
      const contacts = utils.sheet_to_json(worksheet);

      if (Object.keys(contacts).length === 0) {
        setFileLoader(false);
        showErrorToast(notification, "No contacts found. Add at least one contact to send a broadcast.");
        if (response?.length > 0) {
          setSelectedId1(true);
        }
        return; // Exit early if there are no contacts
      }

      // Process the contacts
      const {
        validData,
        invalidData,
        duplicateData,
        validContacts,
        duplicateContacts,
        invalidContacts,
      } = processContacts(contacts, phoneRegex);

      if (!contacts[0]["mobile-number"]) {
        setFileLoader(false);
        showErrorToast(notification, "Can't Read File. Use Google Sheets / Office Download.");
        if (response?.length > 0) {
          setSelectedId1(true);
        }
        return; // Exit early if the mobile number is not found
      }

      // Determine the new segment data based on selectedIndex
      const newId = response.length + 1; // Use response length to get the new ID
      let newData;

      if (selectedIndex === "send_now") {
        newData = { id: newId, start: 0, end: 0, delay: 0 };
      } else {
        newData = {
          id: newId,
          start: 0,
          end: 0,
          schedule_on: dateCombine || "",
        };
      }

      if (responseFile) {
        const newFileData = {
          id: newId,
          file_name: filesName,
          file_path: responseFile,
          broadcastPartId: null, // Initialize as null
          valid_count: validContacts.length,
          duplicate_count: duplicateContacts.length,
          invalid_count: invalidContacts.length,
          segments: [newData],
        };

        // Prepare payload based on the active tab
        let payLoad;
        if (activeTab === 'file-upload') {
          // Payload for file upload
          payLoad = {
            file_name: filesName,
            file_path: responseFile,
            brand_id: currentBrand?.brand_id,
            broadcast_part_type: 'file_upload'
          };
        } else if (activeTab === 'audience-set' && selectedAudience) {
          // Payload for audience set
          payLoad = {
            brand_id: currentBrand?.brand_id,
            broadcast_part_type: 'audience_set',
            audience_set_id: selectedAudience.id
          };
        }

        const createBroadcastPartResponse = await broadcastPartApi(id, payLoad);

        if (createBroadcastPartResponse?.status === 200) {
          const broadcastPartId = createBroadcastPartResponse.data.id;
          setBroadcastPartId((prevIds) => [...prevIds, broadcastPartId]); // Track all broadcastPartIds
          newFileData.broadcastPartId = broadcastPartId; // Assign the ID to the new file

          // Update the new file data with the assigned broadcastPartId
          const updatedResponse = [...response, newFileData].map(
            (file, index) => ({
              ...file,
              id: index + 1,
              segments:
                selectedIndex === "send_now"
                  ? [{ id: 1, start: 0, end: 0, delay: 0 }]
                  : [
                      {
                        id: 1,
                        start: 0,
                        end: 0,
                        schedule_on: index === 0 ? dateCombine : "",
                      },
                    ],
            })
          );
          setResponse(updatedResponse);
          setResponse1(updatedResponse);

          const updatedData = {
            brand_id: currentBrand?.brand_id,
            broadcast_part_id: broadcastPartId,
            valid_count: validContacts.length,
            duplicate_count: duplicateContacts.length,
            invalid_count: invalidContacts.length,
            file_date_valid: validData,
            file_date_in_valid: invalidData,
            file_date_duplicate: duplicateData,
          };

          await broadcastPartFileData(id, broadcastPartId, updatedData); // Handle file data response
        }
      }
    } catch (error) {
      console.error("Error uploading file:", error);
      setFileLoader(false);
    } finally {
      setFileLoader(false);
    }
  };

  const processContacts = (contacts, phoneRegex) => {
    const uniquePhoneNumbers = new Set();
    const validContacts = [];
    const duplicateContacts = [];
    const invalidContacts = [];

    const brandPlanLimits = {
      "magnum": 100000,
      "growth": 50000,
      "starter": 25000,
    };

    const limit =
      brandPlanLimits[currentBrand?.brand_billing_plan_name] || contacts.length;
    const contactsToValidate = contacts.slice(0, limit);

    contactsToValidate.forEach((contact) => {
      const phoneNumber = contact["mobile-number"]
        ? String(contact["mobile-number"])?.replace(/\s+/g, '')
        : null;

      // Validate only if there is a mobile number
      if (phoneNumber) {
        const countryCode = contact["country-code"]
          ? String(contact["country-code"])?.replace(/\s+/g, '')
          : "";

        if (!countryCode) {
          // Mark as invalid if either phone number or country code is missing
          invalidContacts.push({
            ...contact,
            reason: !countryCode
              ? "Missing country code"
              : "Missing phone number",
          });
          return;
        }

        const fullPhoneNumber = `${countryCode} ${phoneNumber}`;

        const isValid = phoneRegex.test(fullPhoneNumber);
        const isDuplicate = uniquePhoneNumbers.has(fullPhoneNumber);

        if (isValid && !isDuplicate) {
          uniquePhoneNumbers.add(fullPhoneNumber);
          validContacts.push(contact);
        } else if (isValid && isDuplicate) {
          duplicateContacts.push(contact);
        } else {
          invalidContacts.push(fullPhoneNumber);
        }
      }
    });
    const mapContactData = (contactList) =>
      contactList.map((contact) => {
        const getFieldValue = (field) => {
          let value = contact[field];

          if (value !== undefined && value !== null && value !== "") {
            value = String(value).trim();

            if (field === "first-name" || field === "last-name") {
              value = value.replace(/[^a-zA-Z\s]/g, "");
            }

            return value || null;
          }

          return null;
        };

        const details = {
          "email-id": getFieldValue("email-id"),
          "last-name": getFieldValue("last-name"),
          "media-url": getFieldValue("media-url"),
          "shop-name": getFieldValue("shop-name"),
          "first-name": getFieldValue("first-name"),
          "website-url": getFieldValue("website-url"),
          "mobile-number": getFieldValue("mobile-number"),
          "custom-variable1": getFieldValue("custom-variable1"),
          "custom-variable2": getFieldValue("custom-variable2"),
          "custom-variable3": getFieldValue("custom-variable3"),
          "custom-variable4": getFieldValue("custom-variable4"),
          "custom-variable5": getFieldValue("custom-variable5"),
          "otp-number": getFieldValue("otp-number"),
        };
        // Filter out keys with null values
        const filteredDetails = Object.fromEntries(
          Object.entries(details).filter(([_, value]) => value !== null)
        );

        return {
          row: contact.__rowNum__ || null,
          mobile1: getFieldValue("country-code")
            ? getFieldValue("country-code") +
              " " +
              getFieldValue("mobile-number")?.replace(/\s+/g, "")
            : getFieldValue("mobile-number")?.replace(/\s+/g, "") || null,
          details: filteredDetails,
        };
      });

    if (validContacts.length === 0 && contacts[0]["mobile-number"]) {
      setFileLoader(false);
      showErrorToast(notification, "No contacts found. Add at least one contact to send a broadcast.");
      return;
    }

    const validData =
      validContacts.length > 0 ? mapContactData(validContacts) : 0;
    const invalidData =
      invalidContacts.length > 0 ? mapContactData(invalidContacts) : 0;
    const duplicateData =
      duplicateContacts.length > 0 ? mapContactData(duplicateContacts) : 0;

    return {
      validData,
      invalidData,
      duplicateData,
      validContacts,
      duplicateContacts,
      invalidContacts,
    };
  };

  // Function to fetch member count for an audience set
  const fetchAudienceSetMemberCount = async (audience) => {
    try {
      const { selection_criteria, added_contact_person_ids = [], removed_contact_person_ids = [] } = audience.details || {};
      
      // Encode the selection criteria
      const filters = selection_criteria ? Base64.encode(JSON.stringify(selection_criteria)) : '';

      // Fetch just the first page with limit=1 to get the total count
      const response = await AudienceSetMembersList(
        currentBrand?.brand_id,
        `filters=${filters}`,
        added_contact_person_ids,
        removed_contact_person_ids,
        1, // page
        1  // limit=1 since we only need the count
      );
      
      const count = response?.data?.data?.pagination?.total_count || 0;
      return count;
    } catch (error) {
      console.error('Error in fetchAudienceSetMemberCount:', error);
      return 0;
    }
  };

  // Fetch audience sets
  const fetchAudienceSets = useCallback(async () => {
    try {
      setLoading(true);
      const res = await AudienceSetList(currentBrand?.brand_id);
      
      if (res?.data?.data) {
        setAudienceSets(res.data.data);
      } else {
        console.error('No data in response:', res);
        setAudienceSets([]);
      }
    } catch (error) {
      console.error('Error fetching audience sets:', error);
      showErrorToast(notification, "Failed to fetch audience sets");
    } finally {
      setLoading(false);
    }
  }, [currentBrand?.brand_id, dispatch, toggleToast]);

  useEffect(() => {
    if (activeTab === 'audience-set') {
      fetchAudienceSets();
    }
  }, [activeTab, fetchAudienceSets]);

  const handleAudienceSelect = async (audience) => {
    try {
      // Don't allow selecting an audience if a file is already uploaded or another audience is selected
      const hasFileUpload = response?.some(item => item.broadcastPartId && !item.audience_set_id);
      const hasExistingAudience = response?.some(item => item.audience_set_id);
      
      if (hasFileUpload) {
        showErrorToast(notification, "Please remove the existing file upload before selecting an audience set");
        return;
      }
      
      if (hasExistingAudience) {
        showErrorToast(notification, "Please remove the existing audience set before selecting another one");
        return;
      }

      setLoading(true);
      
      // Fetch the member count for the selected audience
      const memberCount = await fetchAudienceSetMemberCount(audience);
      
      // Prepare payload for audience set
      const payLoad = {
        brand_id: currentBrand?.brand_id,
        broadcast_part_type: 'audience_set',
        audience_set_id: audience.id
      };
      
      // Set the selected broadcast part type
      setSelectedBroadcastPartType('audience_set');

      // Call the API to create a new broadcast part
      const createBroadcastPartResponse = await broadcastPartApi(broadcastId, payLoad);

      if (createBroadcastPartResponse?.status === 200) {
        const broadcastPartId = createBroadcastPartResponse.data.id;
        setBroadcastPartId((prevIds) => [...prevIds, broadcastPartId]);
        
        // Create the new audience data object with the member count
        const newAudienceData = {
          id: response.length + 1,
          broadcastPartId: broadcastPartId,
          audience_set_id: audience.id,
          name: audience.name,
          created_at: audience.created_at,
          segments: selectedIndex === 'send_now' 
            ? [{ id: 1, start: 0, end: 0, delay: 0 }] 
            : [{ id: 1, start: 0, end: 0, schedule_on: dateCombine }],
          valid_count: memberCount, // These counts would come from the API in a real implementation
          duplicate_count: 0,
          invalid_count: 0
        };

        // Update the response state
        const updatedResponse = [...response, newAudienceData];
        setResponse(updatedResponse);
        setResponse1(updatedResponse);
        
        // Set the selected audience with the member count
        setSelectedAudience({
          ...audience,
          broadcastPartId: broadcastPartId,
          memberCount: memberCount
        });
      }
    } catch (error) {
      console.error('Error creating broadcast part for audience set:', error);
      showErrorToast(notification, "Failed to select audience set. Please try again.");
    } finally {
      setLoading(false);
    }
  };

  const handleDeleteAudience = async (broadcastPartId) => {
    if (!broadcastPartId) {
      // If no broadcastPartId, just clear the selection
      setSelectedAudience(null);
      return;
    }
    
    setLoading(true);
    
    try {
      const res = await broadcastPartDeleteApi(broadcastId, broadcastPartId, currentBrand?.brand_id);
      
      if (res.status === 200) {
        // Filter out the deleted audience from the response
        const updatedResponse = response.filter(
          (item) => item.broadcastPartId !== broadcastPartId
        );
        
        // Update the response states
        setResponse(updatedResponse);
        setResponse1(updatedResponse);
        setSelectedAudience(null);
        
        // Reset the selected broadcast part type
        setSelectedBroadcastPartType(null);
        
        // Update the broadcast part IDs
        setBroadcastPartId((prevIds) => 
          prevIds.filter(id => id !== broadcastPartId)
        );

        showSuccessToast(notification, 'Audience set removed successfully');
      }
    } catch (error) {
      console.error('Error deleting audience set:', error);
      showErrorToast(notification, "Failed to remove audience set. Please try again.");
    } finally {
      setLoading(false);
    }
  };

  const filteredAudienceSets = Array.isArray(audienceSets) 
    ? audienceSets.filter(audience => 
        audience?.name?.toLowerCase().includes(searchQuery.toLowerCase())
      )
    : [];

  const renderFileUploadTab = () => (
    <>
      <div className="flex-column">
        <span className="audience">Define Audience</span>
        <div className="Audience_download flex-row w-100 space-between align-center">
          <span className="audience-content">
            Upload a single audience list or combine multiple lists to tailor
            your message to specific groups
          </span>
          <a href={downloadUrl}>
            <div className="flex-row align-center pointer">
              <img
                src={ICONS?.AudienceDownloadIcon}
                alt=""
                style={{ width: "16px", height: "16px" }}
              />
              <span>Download Sample</span>
            </div>
          </a>
        </div>
      </div>

      <div
        className="upload-container "
        onDragOver={handleDrag}
        onDrop={handleDrop}
      >
        <label className="uploadLabel flex-column justify-center align-center">
          <input
            className="input"
            type="file"
            onChange={handleChange}
            accept=".xlsx"
          />
          <div className="duplicateButton flex-row align-center justify-center">
            {fileLoader ? (
              <div
                className="loaderWrapper flex-row align-center justify-center pt-10 "
                style={{ width: "60px" }}
              >
                <Loader Width={20} Height={20} loaderBg="white" />
              </div>
            ) : (
              "Choose file"
            )}
          </div>
          <div className="flex-column">
            <p>( Drag & Drop the file to upload )</p>
            <p>.xlsx</p>
          </div>
        </label>
      </div>

      <FileDownload
        key={response?.id}
        file_name={response?.file_name}
        broadCasts={broadCasts}
        broadcastId={broadcastId}
        response={response}
        setResponse={setResponse}
        setResponse1={setResponse1}
        setSelectedId1={setSelectedId1}
        setIndexRem={setIndexRem}
        setSelectedIndexSegments={setSelectedIndexSegments}
        selectedIndex={selectedIndex}
      />
    </>
  );

  const formatFileSize = (audience) => {
    const count = audience?.memberCount || audience?.valid_count || 0;
    return `${count} contact${count !== 1 ? 's' : ''}`;
  };

  const renderAudienceSetTab = () => {

    return (
      <div className="audience-set-tab">
        <div className="search-container mb-7">
          <Input
            placeholder="Search audience sets"
            prefix={<SearchOutlined />}
            value={searchQuery}
            onChange={(e) => setSearchQuery(e.target.value)}
            style={{ width: '100%', maxWidth: '400px' }}
          />
        </div>
        
        <div className="upload-container" style={{ minHeight: '200px', maxHeight: '300px', overflowY: 'auto', padding: '16px' }}>
          {loading ? (
            <div className="flex-row justify-center align-center" style={{ height: '100%' }}>
              <Loader Width={24} Height={24} />
            </div>
          ) : filteredAudienceSets.length > 0 ? (
            <div className="audience-list">
              {filteredAudienceSets.map((audience) => (
                <div 
                  key={audience.id}
                  className={`audience-item ${selectedAudience?.id === audience.id ? 'selected' : ''}`}
                  onClick={() => handleAudienceSelect(audience)}
                  style={{
                    display: 'flex',
                    justifyContent: 'space-between',
                    alignItems: 'center',
                    padding: '12px 16px',
                    marginBottom: '8px',
                    backgroundColor: selectedAudience?.id === audience.id ? '#f0f7ff' : '#fff',
                    border: `1px solid ${selectedAudience?.id === audience.id ? '#1890ff' : '#f0f0f0'}`,
                    borderRadius: '4px',
                    cursor: 'pointer',
                    transition: 'all 0.2s'
                  }}
                >
                  <div>
                    <div style={{ fontWeight: 500, marginBottom: '4px' }}>{audience.name}</div>
                    {audience.description && (
                      <div style={{ fontSize: '12px', color: '#8c8c8c' }}>
                        {audience.description.split(' ').length > 10
                          ? `${audience.description.split(' ').slice(0, 10).join(' ')}...`
                          : audience.description
                        }
                      </div>
                    )}
                  </div>
                  <div style={{ fontSize: '12px', color: '#8c8c8c' }}>
                    {new Date(audience.created_at).toLocaleDateString()}
                  </div>
                </div>
              ))}
            </div>
          ) : (
            <div className="flex-row justify-center align-center" style={{ height: '100%' }}>
              <Empty 
                description={
                  <span style={{ color: '#8c8c8c' }}>
                    {searchQuery 
                      ? 'No audience sets found matching your search' 
                      : 'No audience sets found. Please create an audience set first.'
                    }
                  </span>
                }
                style={{ margin: '40px 0' }}
              />
            </div>
          )}
        </div>

        {selectedAudience && (
          <div style={{ 
            marginTop: '16px',
            backgroundColor: '#fff',
            border: '1px solid #f0f0f0',
            borderRadius: '8px',
            padding: '12px',
            display: 'flex',
            alignItems: 'center',
            justifyContent: 'space-between'
          }}>
            <div style={{ display: 'flex', alignItems: 'center', gap: '12px' }}>
              <div style={{
                width: '40px',
                height: '40px',
                borderRadius: '4px',
                backgroundColor: '#f0f7ff',
                display: 'flex',
                alignItems: 'center',
                justifyContent: 'center'
              }}>
                <Group />
              </div>
              <div>
                <div style={{ 
                  fontSize: '14px',
                  color: '#262626',
                  marginBottom: '4px',
                  fontWeight: 500
                }}>
                  {selectedAudience.name}
                </div>
                <div style={{ 
                  fontSize: '12px',
                  color: '#8c8c8c',
                  display: 'flex',
                  gap: '12px'
                }}>
                  <span>{formatFileSize(selectedAudience)}</span>
                  <span>•</span>
                  <span>Uploaded on {new Date(selectedAudience.created_at).toLocaleDateString()}</span>
                </div>
              </div>
            </div>
            <Button 
              type="text" 
              icon={loading ? (
                <Loader Width={20} Height={20} loaderBg="white" />
              ) : (
                <DeleteOutlined style={{ color: '#ff4d4f' }} />
              )}
              onClick={(e) => {
                e.stopPropagation();
                handleDeleteAudience(selectedAudience.broadcastPartId);
              }}
              disabled={loading}
            />
          </div>
        )}
      </div>
    );
  };

  return (
    <div className="Broadcast-segments">
      <ConfigProvider
        theme={{
          components: {
            Tabs: {
              inkBarColor: "#05805d", // active bar color
              colorPrimary: "#05805d",
            },
          },
        }}
      >
        <Tabs
        activeKey={activeTab}
        onChange={(key) => {
          // Allow changing tabs freely, we'll handle the validation when user tries to select an audience
          setActiveTab(key);
        }}
        items={[
          {
            key: 'file-upload',
            label: 'File Upload',
            children: renderFileUploadTab(),
            disabled: false // Never disable the tab itself
          },
          ...(isAudienceManagementSystemEnabled ? [
            {
              key: 'audience-set',
              label: 'Audience Set',
              children: renderAudienceSetTab(),
              disabled: false // Never disable the tab itself
            }
          ] : []),
        ]}
        className="Broadcast-segments"
      />
      </ConfigProvider>
    </div>
  );
};

export default Define_Audience;
